import createSubmit from '../../Form/createSubmitButton.jsx'
import {name} from './ConfirmRegistrationForm.jsx'

export default createSubmit(name)